import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { EXPERT_CTA, EXPERT_CTA_FOR_TAILOR_REGION, PRO_CTA, UNLOCK_CTA } from 'src/const';
import { User } from 'src/interfaces/iuser';
import { checkUserTailorMarketAccess } from 'src/utils/functions';

export const useUpgradeMesageProFeature = () => {
  const user: User = useSelector(state => (state as any).dashboard.user);
  const search = useSelector(state => (state as any).dashboard.search);
  const userTailorMarketAccess = useMemo(() => checkUserTailorMarketAccess(user, search), [
    user,
    search,
  ]);
  if (!userTailorMarketAccess) {
    // return EXPERT_CTA_FOR_TAILOR_REGION;
    return EXPERT_CTA;
  } else if (user.subscriptionPlan === 'starter') {
    // return PRO_CTA;
    return EXPERT_CTA;
  } else {
    return UNLOCK_CTA;
  }
};

export const useUpgradeMesageExpertFeature = () => {
  const user: User = useSelector(state => (state as any).dashboard.user);
  return !['expert', 'scale'].includes(user.subscriptionPlan) ? EXPERT_CTA : UNLOCK_CTA;
};

export const useUpgradeMesageForMainKPI = timePeriod => {
  const user: User = useSelector(state => (state as any).dashboard.user);
  const search = useSelector(state => (state as any).dashboard.search);
  const userTailorMarketAccess = useMemo(() => checkUserTailorMarketAccess(user, search), [
    user,
    search,
  ]);
  if (!userTailorMarketAccess) {
    // return EXPERT_CTA_FOR_TAILOR_REGION;
    return EXPERT_CTA;
  } else if (user.subscriptionPlan === 'starter') {
    // return PRO_CTA;
    return EXPERT_CTA;
  } else if (timePeriod === 36 && !['expert', 'scale'].includes(user.subscriptionPlan)) {
    return EXPERT_CTA;
  } else {
    return UNLOCK_CTA;
  }
};

export const useUpgradeMesageForHosts = dashboardLayoutView => {
  const user: User = useSelector(state => (state as any).dashboard.user);
  const search = useSelector(state => (state as any).dashboard.search);
  const userTailorMarketAccess = useMemo(() => checkUserTailorMarketAccess(user, search), [
    user,
    search,
  ]);

  if (!userTailorMarketAccess && dashboardLayoutView == 'dashboard') {
    return EXPERT_CTA_FOR_TAILOR_REGION;
  } else if (user.subscriptionPlan === 'starter' && dashboardLayoutView == 'dashboard') {
    // return PRO_CTA;
    return EXPERT_CTA;
  } else if (user.subscriptionPlan === 'starter' && dashboardLayoutView == 'map') {
    return EXPERT_CTA;
  } else if (user.subscriptionPlan == 'pro' && dashboardLayoutView == 'map') {
    return EXPERT_CTA;
  } else {
    return UNLOCK_CTA;
  }
};

export const useUpgradeMesageBasedOnFilterTab = currentFilterTab => {
  const user: User = useSelector(state => (state as any).dashboard.user);

  if (user.subscriptionPlan === 'starter') {
    // return currentFilterTab != 'listing' ? EXPERT_CTA : PRO_CTA;
    return EXPERT_CTA;
  } else if (
    currentFilterTab != 'listing' &&
    !['expert', 'scale'].includes(user.subscriptionPlan)
  ) {
    return EXPERT_CTA;
  } else {
    return UNLOCK_CTA;
  }
};
